import React from "react";
import { DatePicker } from "antd";
import { DateRangePickerStyled } from "./date-range-picker.styles";
import { dateRangePickerProps } from "./date-range-picker.type";
import { Typography } from "@mui/material";
import { CalendarIcon } from "../../../utils/svg-components";

const DateRangePickerField = (props) => {
  const {
    onChange,
    placeholder = ["Start", "Stop"],
    name,
    status = "",
    format = "MM-DD-YYYY",
    size = "small",
    defaultValue = [],
    label,
    isRequired,
    disabled,
  } = props;
  const { RangePicker } = DatePicker;

  return (
    <DateRangePickerStyled>
      {label && (
        <div style={{ marginBottom: "8px" }}>
          <Typography variant={"body1"}>
            {label}
            {isRequired && "*"}
          </Typography>
        </div>
      )}
      <RangePicker
        id={name}
        format={format}
        onChange={onChange}
        disabled={disabled}
        style={{
          height: "36px",
          borderRadius: "3px",
          border: "1px solid #080425",
        }}
        placeholder={placeholder}
        status={status}
        defaultValue={defaultValue}
        size={size}
        suffixIcon={<CalendarIcon />}
        separator={
          <div
            style={{
              background: "#080425",
              height: "20px",
              width: "1px",
              padding: "0",
            }}
          ></div>
        }
      />
    </DateRangePickerStyled>
  );
};

DateRangePickerField.propTypes = dateRangePickerProps;

export default React.memo(DateRangePickerField);
